import React from 'react';

const Loader = () => {
    return (
        <li class="loading-wheel-item"><div class="loading-wheel"></div></li>
    );
}
 
export default Loader;